import React from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile } from '@pascal/pascal-core';
import { gameStore } from '../../../store/gameStore';

export const TimerBlock = observer(({ innerComp: InnerComp }) => {
  const { timerDuration, time, isBetsClosed } = gameStore;
  return (
    <InnerComp
      isTimerOn={+time >= 0 && !isBetsClosed}
      time={time}
      duration={timerDuration}
      isMobile={isMobile()}
    />
  );
});
